import { render } from "./modal-group-selection.vue?vue&type=template&id=b96e9484&scoped=true"
import script from "./modal-group-selection.vue?vue&type=script&lang=js"
export * from "./modal-group-selection.vue?vue&type=script&lang=js"

import "./modal-group-selection.vue?vue&type=style&index=0&id=b96e9484&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b96e9484"],['__file',"src/components/modal-group-selection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b96e9484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b96e9484', __exports__)) {
    api.reload('b96e9484', __exports__)
  }
  
  module.hot.accept("./modal-group-selection.vue?vue&type=template&id=b96e9484&scoped=true", () => {
    api.rerender('b96e9484', render)
  })

}


export default __exports__